import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { H2, H4, S05, Text } from '../../../../../../../../../Styles/typography'
import { BatchTabEl } from '../Elements'

function BatchTab({
  userType,
  data: {
    id,
    name,
    registrationCount,
    requestCount,
    classCount,
    completedClasses,
    nextClass,
  },
  match: {
    params: { livDemyID, courseURL },
  },
  isActive,
}) {
  const progress = classCount > 0 ? (completedClasses / classCount) * 100 : 0

  return (
    <Link to={`/${livDemyID}/course/${courseURL}/dashboard/${id}`}>
      <BatchTabEl progress={progress} isActive={isActive}>
        <div className='info'>
          <H4>{name}</H4>
          <div className='stats'>
            <S05>{registrationCount} Students Registered</S05>
            {userType === "teacher" && (
              <S05>{requestCount} Enrollment Requests</S05>
            )}
          </div>
          <div className='progress-bar'>
            <div className='progress' />
          </div>
          <S05>
            {completedClasses} / {classCount} classes
          </S05>
        </div>
        {progress !== 100 && (
          <div className='nextClass'>
            <Text>Next: {nextClass.date.toLowerCase()}</Text>
            <H2>{nextClass.day}</H2>
            <Text>{nextClass.time}</Text>
          </div>
        )}
      </BatchTabEl>
    </Link>
  )
}

export default withRouter(BatchTab)
